import {
    useRef
} from 'react';

import { SimpleGrid } from '@mantine/core';

import { useProducts } from '../hooks/useProducts.ts';
import { useProductsSelection } from '../hooks/useProductsSelection.ts';
import { useTableColumns } from '../hooks/useTableColumns.tsx';

import {
    MantineDataTable,
    TableSearchForm,
} from '@flexinet/ui-components';
import { DataTableTokenPagination } from "../../../components/DataTableTokenPagination.tsx";
import { ProductStatus } from '../types';

interface RecordsTableProps {
    statusFilter?: ProductStatus | null;
}

export const RecordsTable = ({ statusFilter }: RecordsTableProps) => {
    const {selectedRecords, setSelectedRecords} = useProductsSelection();
    const { columns } = useTableColumns();

    const {
        items,
        totalCount,
        loading,
        nextToken,
        fetchRecords,
        handleFilterByKeyword
    } = useProducts(statusFilter);

    const scrollViewportRef = useRef<HTMLDivElement>(null);

    return (
        <SimpleGrid verticalSpacing='xl' m='sm'>
            <TableSearchForm handleFilterByKeyword={handleFilterByKeyword} />

            <MantineDataTable
                columns={columns}
                records={items}
                selectedRecords={selectedRecords}
                onSelectedRecordsChange={setSelectedRecords}
                fetching={loading}
                onScrollToBottom={() => fetchRecords()}
                scrollViewportRef={scrollViewportRef}
                withTableBorder={true}
            />

            <DataTableTokenPagination totalCount={totalCount.toString()} nextToken={nextToken} handleLoadMore={fetchRecords} />

        </SimpleGrid>
    );
};